import { ContractWorkflow, Document, DocumentType, WorkflowResultData } from "~/model/Workflow"
import { User } from "~/model/User"
import { BusinessCompany } from "./Company"
import { DocWorkflowNos } from "~/model/ContractDocument"

export type Contract = {
  id: number
  companyId: number
  userId: number
  agentUserId: number
  agentCode: string
  agentCompanyName: string
  agentUser: User
  managementUserId: number
  managementCode: string
  managementUser: User
  contractorConfirm?: boolean
  name1: string
  name2: string
  fullName: string
  kana1: string
  kana2: string
  fullKana: string
  tel: string
  email: string
  zip: string
  prefectureId: number
  prefecture: Prefecture
  documents: Document[]
  city: string
  address1: string
  address2: string
  status: number
  latestMemo: any
  applicationDate: Date | null
  completedDate: Date | null
  canceledDate: Date | null
  cancelReason: number
  meetingDate: string // Date | null
  videoId: string
  createdAt: Date | null
  updatedAt: Date | null
  deletedAt: Date | null
  property: any
  contractCode?: string
  insuranceId?: number
  insuranceCode?: string
  insuranceEmail?: string
  insuranceSentDate?: Date | null
  businessCompanyId: number
  businessCompany: BusinessCompany
  businessCompanyName: string
  typeContractor: string
  price: number
  resident: Resident
  procedureCode?: string
  procedureCodeSecond?: string
  guarantee?: Guarantee
  guarantee2: Guarantee
  flagGuarantee: boolean
  flagGuarantee2: boolean
  version?: number
  transactionType?: TransactionTypes
  optionSign?: string
  idUserCompany?: number
  contractType?: ContractTypeValues
  listcompanyAgency: any
  fundInformation?: any
  resonaCode?: string
  resonaDateRegister?: string
  resonaEmail?: string
  resonaFullkana?: string
  resonaPasscode?: string
  resonaRegisterStatus?: string
  resonaSentDate?: string
  japaneseTel?: string | null
  ledgerStatus?: number
  undraftDate?: Date | null
  agencyConfirm?: boolean
  ownerConfirm?: boolean
  fundConfirm?: boolean
}

type Guarantee = {
  address1: string
  address2: string
  addressPrefecture: string
  email: string
  firstName: string
  firstNameFurigana: string
  id: number
  lastName: string
  lastNameFurigana: string
  phone: string
}

export type ContractView = {
  id: number
  userId: number
  companyId: number
  status: number
  name: string
  tel: string
  email: string
  videoId: string
  residentName: string
  propertyFullName: string
  propertyName: string
  propertyRoomNumber: string
  agentUserId: number
  agentUserName: string
  agentUserEmail: string
  agentCompanyId: number
  agentCompanyName: string
  managementUserId: number
  managementUserName: string
  managementUserEmail: string
  managementCompanyId: number
  managementCompanyName: string
  meetingDate: Date | null
  canceledDate: Date | null
  completedDate: Date | null
  createdAt: Date | null
}

export type SignContract = {
  contractWorkflow?: ContractWorkflow
} & Contract

export type SignContractWithListDocs = {
  contractWorkflow?: ContractWorkflow
  unsignedDocuments?: Document[]
  signedDocuments?: Document[]
  signedResidentDocuments?: Document[]
  receivedDocuments?: Document[]
  nextSignDocuments?: Document[]
  receivedDocumentsNotComplete?: Document[]
  unsignedDocumentsForResident?: Document[]
  nextRecvDocuments?: Document[]
  otherITDocs?: Document[]
  isCheckedTermAndCondition?: boolean
  otpCode: string
  optionSign: string
  nameOwner: string
  emailOwner: string
  unshownDisabledDocuments?: { id: number; workflowName: string }[]
} & Contract

export type Prefecture = {
  id: number
  name: string
  title: string
  createdAt: Date | null
  updatedAt: Date | null
  deletedAt: Date | null
}

export type SignDocument = {
  id: number
  contractDocumentId: number
  hash: string
  workflowName: string
  workflowType: DocumentType
  isSignedFile: boolean
  pdfId: string
  columns: number[]
  fileName: string
  updatedAt: string
  docWorkflowNo?: DocWorkflowNos
  workflowData?: WorkflowResultData[]
}

export type OnlineSignContract = {
  id: number
  agentName: string
  fullName: string
  fullKana: string
  email: string
  tel: string
  zip: string
  address2: string
  meetingDate: string
  address1: string
  signDocuments: SignDocument[]
}

export interface Resident {
  id: number
  contractId: number
  name1: string
  name2: string
  fullName: string
  kana1: string
  kana2: string
  fullKana: string
  tel: string
  email: string
  hasResident: number
  createdAt: string
  updatedAt: string
  deletedAt: any
}
export interface Owner {
  name: string
  email: string
}

export enum TransactionTypes {
  DEDICATED_AGENT = "専任媒介", //Môi giới chuyên dụng
  DEFAULT_AGENT = "一般媒介", // Môi giới thông thường
  AGENT = "媒介", // Môi giới
  COLLECTION_AGENCY = "貸主代理", // Đại diện thu tiền
  SUBLEASE = "サブリース", // Sublease
  OWNER_ML="貸主" // Master-lease e067
}
export enum ContractTypeTexts {
  SUBLEASE = "サブリース",
  BROKERAGE = "仲介物件", // công ty môi giới gọi là agent
  MASTER_LEASE = "集金代行", // đại diện thu tiền
  MASTER_LEASE_2 = "マスターリース",
}

export enum ContractTypeValues {
  SUBLEASE = "SUBLEASE",
  BROKERAGE = "BROKERAGE",
  MASTER_LEASE = "MASTER_LEASE",
  MASTER_LEASE_2 = "MASTER_LEASE_2",
}

export enum ContractMLFilter {
  NOT_FILTER = 0,
  EXCLUDE_ML = 1,
  ONLY_ML = 2,
}

export const ContractMLFilterOptions = [
  { label: "未設定", value: ContractMLFilter.NOT_FILTER },
  { label: "マスターリース以外", value: ContractMLFilter.EXCLUDE_ML },
  { label: "マスターリースのみ", value: ContractMLFilter.ONLY_ML },
]

export enum ContractStatusType {
  /**
   * 契約準備中
   */
  DOCUMENT_PREPARATION = 0,
  /**
   * 重説準備中
   */
  MEETING_PREPARATION = 10,
  /**
   * 重説準備完了
   */
  READY = 20,
  /**
   * IT重説完了
   */
  IT_READY = 21,
  /**
   * 契約済
   */
  SIGNED = 30,
  /**
   * 契約完了
   */
  COMPLETE = 40, // Old status, not used anymore
  /**
   * キャンセル
   */
  CANCEL = 50,

  DRAFT = 60,
}

export enum ResonaStatus {
  SUCCESS = "00",
  WARNING = "01",
  CANCEL = "10",
  ERROR = "20",
  DEFAULT = "30",
  SENDED = "40",
  REGISTING = "50",
  RESEND = "60",
}

export const ResonaStatusText = {
  [ResonaStatus.SUCCESS]: "手続き完了",
  [ResonaStatus.WARNING]: "手続き失敗",
  [ResonaStatus.CANCEL]: "手続き失敗",
  [ResonaStatus.ERROR]: "手続き失敗",
  [ResonaStatus.DEFAULT]: "ー",
  [ResonaStatus.SENDED]: "メール送信済",
  [ResonaStatus.REGISTING]: "手続き中",
  [ResonaStatus.RESEND]: "メール再送信済",
}
